/**
 * Convert URLs to relative paths.
 * Absolute URLs (e.g. http://localhost:8080/api/files/...) become relative (/api/files/...).
 */
// Format social media links
export function formatSocialLink(type, value) {
  if (!value) return '';

  if (value.startsWith('http://') || value.startsWith('https://')) {
    return value;
  }

  const cleanValue = value.replace(/^[@/]+/, '');

  switch (type) {
    case 'telegram':
      if (!cleanValue.includes('/')) {
        return `https://t.me/${cleanValue}`;
      }
      return `https://t.me/${cleanValue}`;

    case 'instagram':
      if (!cleanValue.includes('/')) {
        return `https://instagram.com/${cleanValue}`;
      }
      return `https://instagram.com/${cleanValue}`;

    case 'whatsapp':
      if (value.startsWith('http://') || value.startsWith('https://')) {
        return value;
      }
      if (value.includes('wa.me') || value.includes('whatsapp.com')) {
        return `https://${value}`;
      }
      const persianToEnglish = {
        '۰': '0', '۱': '1', '۲': '2', '۳': '3', '۴': '4',
        '۵': '5', '۶': '6', '۷': '7', '۸': '8', '۹': '9'
      };
      let phoneNumber = value;
      for (const [persian, english] of Object.entries(persianToEnglish)) {
        phoneNumber = phoneNumber.replace(new RegExp(persian, 'g'), english);
      }
      phoneNumber = phoneNumber.replace(/[^\d+]/g, '');
      phoneNumber = phoneNumber.replace(/\+/g, '');
      return `https://wa.me/${phoneNumber}`;

    case 'bale': {
      if (value.startsWith('http://') || value.startsWith('https://')) {
        return value;
      }
      return `https://ble.ir/${cleanValue}`;
    }

    case 'rubika': {
      if (value.startsWith('http://') || value.startsWith('https://')) {
        return value;
      }
      return `https://rubika.ir/${cleanValue}`;
    }

    default:
      return value;
  }
}

export function normalizeImageUrl(url) {
  if (!url) return url;
  if (url.startsWith('/')) return url;
  try {
    const urlObj = new URL(url);
    return urlObj.pathname + urlObj.search;
  } catch (e) {
    return url;
  }
}

/**
 * Returns relative image URL for display. Accepts paths like /api/files/...
 */
export function getImageUrl(imageUrl) {
  if (!imageUrl) return null;
  if (imageUrl.startsWith('/')) return imageUrl;
  return normalizeImageUrl(imageUrl);
}
